{
  "rampInfoCard": {
    "labels": {
      "aircraft": "Aircraft",
      "utilization": "Utilization",
      "wind": "Wind",
      "trips": "Trips",
      "grossDimensions": "Gross Dimensions",
      "parkableArea": "Parkable Area"
    },
    "tooltips": {
      "aircraftOnRamp": "Aircraft parked within ramp outline / All aircraft shown on screen.",
      "parkableArea": "Outlined ramp areas, excluding those marked as not parkable (eg taxiways, obstacles).",
      "utilization": "Aircraft parked within ramp outline / All aircraft shown on screen. (Note aircraft counts as parked when main wheels are within the overall ramp outline)",
      "grossDimensions": "Basic length and width of ramp outline",
      "trips": "Active trips / Future trips assigned to this ramp",
      "wind": {
        "loading": "Current wind conditions from nearby weather station (updated every 5 minutes)",
        "error": "Wind data not available from {{stationInfo}}\nLast checked: {{lastUpdated}}\nRefreshes every 5 minutes",
        "current": "Current wind conditions from {{stationInfo}}\nLast updated: {{lastUpdated}}\nRefreshes every 5 minutes"
      }
    }
  },
  "namePrefixes": {
    "allTenants": "[All Tenants]",
    "allTieDownTenants": "[All Tie Down Tenants]"
  },
  "aircraftFinder": {
    "tooltip": "Find aircraft",
    "searchPlaceholder": "Search tail, model, operator",
    "clear": "Clear"
  },
  "autoPark": {
    "dialog": {
      "title": "AutoPark Configuration",
      "tabs": {
        "timeRange": "Time Range",
        "algorithm": "Algorithm"
      },
      "timeRange": {
        "startTime": "Start Time",
        "endTime": "End Time",
        "duration": "Duration",
        "presets": {
          "oneDay": "1 Day",
          "threeDays": "3 Days",
          "sevenDays": "7 Days"
        },
        "tripSelection": "Trips in selected range: {{selected}} of {{total}} selected"
      },
      "buttons": {
        "cancel": "Cancel",
        "run": "Run AutoPark"
      }
    },
    "button": {
      "label": "AutoPark",
      "disabledMessage": "AutoParking is not enabled for this ramp. Enable it in the ramp settings.",
      "tooltip": "AutoPark"
    },
    "decisionLog": {
      "tabs": {
        "spotOccupancy": "Spot Occupancy",
        "listView": "List View",
        "timelineDev": "Timeline (Dev)",
        "decisionLog": "Decision Log ({{count}} aircraft)"
      },
      "statistics": {
        "aircraftPlaced": "Aircraft Placed",
        "successRate": "Success Rate",
        "unplacedAircraft": "Unplaced Aircraft",
        "partiallyPlaced": "Partially Placed",
        "partialPlacementNote": "Placed for part of trip",
        "averageMoves": "Average Moves",
        "executionTime": "Execution Time"
      },
      "filters": {
        "all": "All ({{count}})",
        "placed": "Placed ({{count}})",
        "unplaced": "Unplaced ({{count}})"
      },
      "buttons": {
        "close": "Close",
        "apply": "Apply to Ramp",
        "applying": "Applying..."
      },
      "progress": {
        "title": "Applying Results to Database",
        "message": "Saving aircraft placements to the database. Please wait...",
        "itemName": "placement"
      }
    },
    "placementTable": {
      "headers": {
        "status": "Status",
        "tailNumber": "Tail #",
        "spots": "Spot(s)",
        "arrival": "Arrival",
        "departure": "Departure",
        "dwell": "Dwell"
      },
      "summary": {
        "showing": "Showing {{filtered}} of {{total}}",
        "placed": "{{count}} placed",
        "unplaced": "{{count}} unplaced"
      },
      "filters": {
        "all": "All",
        "placed": "Placed",
        "unplaced": "Unplaced",
        "searchPlaceholder": "Search tail numbers..."
      }
    },
    "tripList": {
      "noTrips": "No trips in selected range",
      "unknownAircraft": "Unknown Aircraft"
    },
    "assignSuccess": "{{tailNumber}} assigned to {{locationName}}",
    "assignError": "Failed to assign aircraft",
    "capacityBar": {
      "title": "Spot Capacity",
      "utilization": "{{placed}}/{{total}} spots ({{percent}}% utilized)",
      "legend": {
        "placed": "Placed ({{count}})",
        "available": "Available ({{count}})",
        "filtered": "Filtered ({{count}})",
        "breakdown": {
          "time": "Time ({{count}})",
          "size": "Size ({{count}})",
          "duration": "Duration ({{count}})",
          "disabled": "Disabled ({{count}})",
          "geometry": "Geometry ({{count}})"
        }
      }
    },
    "parkNextButton": {
      "label": "Park Next",
      "tooltip": "Park Next",
      "disabledMessage": "No unplaced aircraft available."
    },
    "decisionLogButton": {
      "tooltip": "View Decision Log",
      "disabledTooltip": "Run AutoPark first to generate decision log"
    },
    "unplacedAircraftDialog": {
      "title": "Unplaced Aircraft at {{time}}",
      "subtitle": "{{count}} aircraft could not be placed at this time",
      "noAircraft": "No unplaced aircraft at this time",
      "closeLabel": "close"
    },
    "timeRangePicker": {
      "durationFormat": {
        "daysHoursMinutes": "{{days}}d {{hours}}h {{minutes}}m",
        "hoursMinutes": "{{hours}}h {{minutes}}m",
        "minutes": "{{minutes}}m"
      }
    },
    "scheduleGanttDialog": {
      "title": "{{rampName}} Schedule",
      "statistics": {
        "aircraftPlaced": "Aircraft Placed",
        "avgUtilization": "Avg Utilization"
      },
      "buttons": {
        "print": "Print",
        "close": "Close",
        "applyToDatabase": "Apply to Database",
        "applying": "Applying..."
      },
      "messages": {
        "unsavedChanges": "You have unsaved changes. Are you sure you want to close?",
        "pendingChanges": "{{count}} unsaved change"
      },
      "labels": {
        "close": "close"
      }
    },
    "editableSpotCell": {
      "otherSpots": "Other Spots"
    },
    "placementTableRowExpanded": {
      "segmentBreakdown": "Segment Breakdown ({{segmentCount}} segment, {{moveCount}} move)",
      "partialPlacement": "Partial Placement - {{count}} Gap",
      "placed": "Placed:",
      "gap": "Gap:",
      "gapLabel": "Gap {{index}}:",
      "noAvailableSpots": "No available spots found",
      "checkDecisionLog": "Check Decision Log tab for detailed filter breakdown"
    },
    "spotSchedulePrintView": {
      "unknownType": "Unknown Type",
      "segmentNotes": "Segment {{current}}/{{total}} ({{moves}} moves)",
      "title": "AutoPark Results - {{rampName}} - {{dateRange}}",
      "statistics": {
        "aircraftPlaced": "Aircraft Placed",
        "successRate": "Success Rate",
        "averageMoves": "Average Moves"
      },
      "tableHeaders": {
        "tailNumber": "Tail Number",
        "aircraftType": "Aircraft Type",
        "arrival": "Arrival",
        "departure": "Departure",
        "duration": "Duration",
        "notes": "Notes"
      },
      "noAircraftScheduled": "(No aircraft scheduled)",
      "unplacedAircraft": "Unplaced Aircraft ({{count}})"
    },
    "placementList": {
      "title": "Parking Assignments",
      "sections": {
        "placed": "Placed",
        "unplaced": "Unplaced"
      },
      "headers": {
        "tail": "Tail",
        "spot": "Spot",
        "zone": "Zone",
        "time": "Time"
      },
      "labels": {
        "allows": "allows",
        "coverage": "coverage",
        "requested": "req",
        "spotLock": "{{count}} spot lock",
        "move": "{{count}} move",
        "moveAt": "@ {{time}}"
      },
      "tooltips": {
        "sizeVerySmall": "Very Small (e.g., Cessna 172)",
        "sizeSmall": "Small (e.g., Citation, Phenom 300)",
        "sizeMidsize": "Midsize (e.g., Challenger 604)",
        "sizeSuperMidsize": "Super-Midsize (e.g., Gulfstream G650)",
        "sizeLarge": "Large (e.g., Global 7500, BBJ)",
        "sizeEnormous": "Enormous (e.g., Commercial airliners)",
        "blocksOne": "Blocks {{tailNumber}} (departs {{departureTime}})",
        "blocksMultiple": "Blocks {{count}} aircraft: {{tailNumbers}}"
      }
    },
    "timelineView": {
      "title": "Spot Occupancy Timeline ({{horizonHours}}h window)",
      "headers": {
        "zone": "Zone",
        "spot": "Spot",
        "day": "Day {{dayNumber}}"
      },
      "rows": {
        "utilization": "Utilization",
        "placed": "Placed",
        "unplaced": "Unplaced"
      },
      "labels": {
        "disabled": "(DISABLED)",
        "stagingArrival": " (A)",
        "stagingDeparture": " (D)"
      },
      "tooltips": {
        "spotDisabled": "Spot disabled (unavailable to algorithm)",
        "zoneDisabled": "{{zoneName}} disabled (all spots in zone unavailable)",
        "spotAndZoneDisabled": "Spot disabled AND {{zoneName}} disabled",
        "departing": "Departing: {{tailNumbers}}",
        "unplacedAircraft": "{{tailNumbers}} (click for details)",
        "blocked": "Blocked by {{tailNumber}} at {{spotId}} (departs {{departureTime}})"
      }
    },
    "parkingConfigForm": {
      "time": {
        "min": "min",
        "hour": "hour",
        "hours": "hours",
        "disabled": "0 min (disabled)"
      },
      "buffer": {
        "title": "Buffer",
        "helpText": "Extra time (minutes) added before arrival and after departure to prevent tight spacing conflicts. Example: Aircraft departs at 10:00. With 15min buffer, spot becomes available at 10:15.",
        "options": {
          "none": "No Buffer (0)",
          "minutes10": "10 minutes",
          "standard": "Standard (15)",
          "high": "High (20)"
        }
      },
      "plannedMoves": {
        "title": "Planned Moves",
        "helpText": "Maximum number of times an aircraft can be relocated during its dwell. 0 = no moves (aircraft stays in one spot). Example: With 1 move allowed, aircraft could park at Spot A (8:00-12:00) then move to Spot B (12:00-16:00).",
        "options": {
          "none": "No Splits (0)",
          "allow1": "Allow 1 Move",
          "allow2": "Allow 2 Moves",
          "allow3": "Allow 3 Moves"
        }
      },
      "allowTrapping": {
        "title": "Allow Trapping",
        "helpText": "When checked, allows placing aircraft in spots that block others' departure paths. When unchecked, only places aircraft in spots that don't trap others (may leave aircraft unplaced).",
        "label": "Allow Trapping"
      },
      "egressWeight": {
        "title": "Egress Weight",
        "helpText": "Controls how strongly the algorithm avoids placements that trap other aircraft. Low (1x): minimal penalty. Medium (2x): moderate penalty. High (5x): strong penalty.",
        "options": {
          "low": "Low (1x)",
          "medium": "Medium (2x)",
          "high": "High (5x)"
        }
      },
      "wasteWeight": {
        "title": "Waste Weight",
        "helpText": "Controls how strongly the algorithm avoids placing small aircraft in oversized spots. Helps reserve premium large spots for large aircraft that actually need them.",
        "options": {
          "disabled": "Disabled (0x)",
          "low": "Low (0.5x)",
          "medium": "Medium (1x)",
          "high": "High (2x)",
          "veryHigh": "Very High (3x)"
        }
      },
      "structuralWeight": {
        "title": "Structural Weight",
        "helpText": "Controls penalty for spots with complex blocking topology. Encourages using 'clean' spots first, saving complex spots as last resort. Low (0.05x): minimal. Standard (0.1x): tiebreaker. High (0.5x): strong preference.",
        "options": {
          "disabled": "Disabled (0x)",
          "low": "Low (0.05x)",
          "standard": "Standard (0.1x)",
          "medium": "Medium (0.2x)",
          "high": "High (0.5x)"
        }
      },
      "zonePriorityWeight": {
        "title": "Zone Priority Weight",
        "helpText": "Controls preference for high-priority zones. Disabled (0x): ignore zones. Low (0.5x): minor preference. Standard (1x): balanced. High (2x): strong preference. Very High (3x): maximum preference.",
        "options": {
          "disabled": "Disabled (0x)",
          "low": "Low (0.5x)",
          "standard": "Standard (1x)",
          "high": "High (2x)",
          "veryHigh": "Very High (3x)"
        }
      },
      "minDwellWeight": {
        "title": "Min Dwell Weight",
        "helpText": "Controls preference for spots with min dwell requirements. Attracts long-stay aircraft to remote/overflow spots and repels short-stay aircraft. Disabled (0x): ignore min dwell. Low (0.5x): minor preference. Standard (1x): balanced. High (2x): strong preference. Very High (3x): maximum preference.",
        "options": {
          "disabled": "Disabled (0x)",
          "low": "Low (0.5x)",
          "standard": "Standard (1x)",
          "high": "High (2x)",
          "veryHigh": "Very High (3x)"
        }
      },
      "arrivalStagingTime": {
        "title": "Arrival Staging Time",
        "helpText": "Duration for arrival servicing operations: unloading, customs, refueling, cleaning. Set to 0 to disable arrival staging. Requires staging zones configured on ramp. Valid range: 0-{{max}} minutes."
      },
      "departureStagingTime": {
        "title": "Departure Staging Time",
        "helpText": "Duration for departure preparation: boarding, final checks, paperwork. Set to 0 to disable departure staging. Requires staging zones configured on ramp. Valid range: 0-{{max}} minutes."
      },
      "quickTurnThreshold": {
        "title": "Quick Turn Threshold",
        "helpText": "Minimum total dwell time to use staging workflow. Aircraft with shorter stays bypass staging and go directly to permanent spots. Valid range: {{min}}-{{max}} minutes.",
        "options": {
          "hour1": "1 hour",
          "hours1_5": "1.5 hours",
          "standard": "Standard (2 hours)",
          "hours3": "3 hours",
          "hours4": "4 hours"
        }
      },
      "sortingStrategy": {
        "title": "Sorting Strategy",
        "helpText": "Controls the order in which aircraft are processed. Size-Constrained: places aircraft with fewer spot options first. Arrival: processes by arrival time. Hybrid: combines size-constrained + longest-dwell.",
        "options": {
          "arrival": "Arrival Order",
          "sizeConstrained": "Size-Constrained First",
          "longestDwell": "Longest Dwell First",
          "latestDeparture": "Latest Departure First",
          "hybrid": "Hybrid (Size + Dwell)",
          "largestFirst": "Largest First"
        }
      }
    },
    "editableTimeCell": {
      "placeholder": "HH:mm"
    },
    "index": {
      "disabledMessages": {
        "autoParkingNotEnabledWithSettings": "AutoParking is not enabled for this ramp. Enable it in the ramp settings.",
        "autoParkingNotEnabled": "AutoParking is not enabled for this ramp.",
        "noUnplacedAircraft": "No unplaced aircraft available."
      },
      "buttons": {
        "checkFit": "Check Fit"
      }
    },
    "spotOccupancyGantt": {
      "sizeCategories": {
        "verySmall": "Very Small",
        "small": "Small",
        "midsize": "Midsize",
        "superMidsize": "Super-Midsize",
        "large": "Large",
        "enormous": "Enormous"
      },
      "errors": {
        "spotNotFound": "Spot not found"
      },
      "unknownType": "Unknown Type",
      "staging": {
        "arrival": "Arrival Staging",
        "departure": "Departure Staging"
      },
      "moveCount": "{{count}} move",
      "currentlyViewing": "Currently viewing:"
    },
    "legend": {
      "title": "Color Legend",
      "auto": "Auto-parked",
      "manual": "Manual",
      "staging": "Staging",
      "locked": "Locked"
    },
    "planningDialog": {
      "title": "AutoPark Planning",
      "stats": {
        "placed": "{{placed}}/{{total}} placed",
        "rate": "{{percent}}% rate"
      },
      "buttons": {
        "preview": "Preview",
        "running": "Running...",
        "print": "Print",
        "settings": "Settings",
        "applyToRamp": "Apply to Ramp",
        "applying": "Applying...",
        "cancel": "Cancel"
      },
      "tooltips": {
        "noTripsInRange": "No trips in time range",
        "unlockToPreview": "Unlock trips to preview",
        "showTripList": "Show trip list",
        "hideTripList": "Hide trip list",
        "configureAlgorithm": "Configure how AutoPark places aircraft. Presets provide quick configurations, or adjust individual weights below."
      },
      "presets": {
        "label": "Preset",
        "balanced": {
          "label": "Balanced (Default)",
          "description": "Good balance of efficiency and stability"
        },
        "conservative": {
          "label": "Conservative",
          "description": "Minimize moves, prioritize stability"
        },
        "aggressive": {
          "label": "Aggressive",
          "description": "Maximize space efficiency"
        },
        "custom": {
          "label": "Custom",
          "description": "Manual configuration"
        }
      },
      "workflow": {
        "title": "How AutoPark Works",
        "step1": "<strong>Select trips</strong> in the left panel to include in planning",
        "step2": "<strong>Lock trips</strong> you want to keep in their current spots",
        "step3": "<strong>Click \"Run Preview\"</strong> to see the algorithm's suggestions",
        "step4": "<strong>Review changes</strong>, then Apply to Ramp",
        "footer": "Locked trips stay put. Unlocked trips may get new spots based on size, arrival time, and zone priority."
      },
      "algorithmSettings": "Algorithm Settings"
    },
    "impactSummary": {
      "locked": "locked",
      "moving": "moving",
      "new": "new",
      "conflicts": "conflicts",
      "tooltips": {
        "locked": "{{count}} trips will stay in their current positions",
        "moving": "{{count}} trips will be moved to new spots",
        "new": "{{count}} previously unassigned trips will get spots",
        "conflicts": "{{count}} trips could not be placed",
        "utilization": "Spot utilization change: {{before}}% → {{after}}%"
      },
      "details": {
        "moves": "Moves ({{count}}):",
        "conflicts": "Conflicts ({{count}}):"
      },
      "unknown": "Unknown"
    },
    "tripList": {
      "title": "Trips ({{selected}}/{{total}} selected)",
      "locked": "{{count}} locked",
      "buttons": {
        "all": "All",
        "none": "None",
        "lockAll": "Lock All",
        "unlockAll": "Unlock All",
        "includeAll": "All",
        "excludeAll": "None"
      },
      "tooltips": {
        "lockAll": "Lock all trips (keep positions)",
        "unlockAll": "Unlock all trips (allow repark)",
        "includeAll": "Include all trips in calculation",
        "excludeAll": "Exclude all trips from calculation",
        "lock": "Lock (keep position)",
        "unlock": "Unlock (allow repark)",
        "clickToLock": "Click to lock position",
        "clickToExclude": "Click to exclude",
        "clickToInclude": "Click to include",
        "keyboardHint": "↑↓ Navigate • Space Cycle • L Lock • Shift+E Exclude all"
      },
      "filter": {
        "placeholder": "Filter by tail, make, model..."
      },
      "emptyState": {
        "title": "No trips in selected time range",
        "hint": "Try expanding the date range using the 3d or 7d buttons above, or check that this ramp has scheduled flights.",
        "addTrips": "Trips can be added from the Schedule view."
      },
      "current": "Current:",
      "invalidDates": "Invalid dates",
      "unknownAircraft": "Unknown",
      "sizeCategories": {
        "small": { "label": "S", "tooltip": "Small (<50ft wingspan)" },
        "medium": { "label": "M", "tooltip": "Medium (50-80ft wingspan)" },
        "large": { "label": "L", "tooltip": "Large (80-120ft wingspan)" },
        "extraLarge": { "label": "XL", "tooltip": "Extra Large (>120ft wingspan)" }
      },
      "noTrips": "No trips in selected time range",
      "assign": "Assign",
      "selectLocation": "Select location",
      "hangarsSection": "Hangars",
      "rampsSection": "Other Ramps"
    }
  },
  "ramp": {
    "referenceModeAlert": "This is your Tie Town Tenant Reference ramp. It only shows your tie down tenants and is distinct from your active Current Ramp."
  },
  "rampPrintLayout": {
    "aircraft": "Aircraft",
    "footer": {
      "automaticallyOptimizedBy": "Automatically optimized by",
      "contactInfo": "Contact us at www.airplx.com or peter@airplx.com."
    }
  },
  "temporalTest": {
    "index": {
      "title": "Temporal Parking Test",
      "testScenario": "Test Scenario",
      "buttons": {
        "running": "Running...",
        "runPlanner": "Run Planner"
      },
      "stats": {
        "planningStatistics": "Planning Statistics",
        "totalAircraft": "Total Aircraft:",
        "placed": "Placed:",
        "unplaced": "Unplaced:",
        "plannedMoves": "Planned Moves:",
        "traps": "Traps:",
        "aircraftBlocking": "aircraft blocking",
        "others": "others",
        "none": "None ✓",
        "expected": "Expected:",
        "placedSlash": "placed /",
        "unplacedSuffix": "unplaced",
        "matchCheck": " ✓",
        "mismatch": " (mismatch)"
      },
      "instructions": "Select a scenario and click \"Run Planner\" to generate parking assignments",
      "decisionLog": "Decision Log ({{count}} events)",
      "parameterGuide": {
        "title": "Parameter Guide",
        "buffer": {
          "title": "Buffer",
          "description": "Extra time (minutes) added before arrival and after departure to prevent tight spacing conflicts.",
          "example": "Example: Aircraft A departs at 10:00. With 15min buffer, spot becomes available at 10:15, preventing rushed turnarounds."
        },
        "plannedMoves": {
          "title": "Planned Moves",
          "description": "Maximum number of times an aircraft can be relocated during its dwell. 0 = no moves (aircraft stays in one spot).",
          "example": "Example: Aircraft arrives 8:00, departs 16:00. With 1 move allowed, it could park at Spot A (8:00-12:00) then move to Spot B (12:00-16:00) if no single spot is available for the full 8 hours."
        },
        "allowTrapping": {
          "title": "Allow Trapping",
          "description": "When checked, allows placing aircraft in spots that block others' departure paths. When unchecked, only places aircraft in spots that don't trap others (may leave aircraft unplaced).",
          "example": "Example: Row has spots A (front) and B (back). Aircraft at B departs at 14:00, aircraft at A departs at 16:00. With trapping disallowed, B cannot be used (would be blocked). With trapping allowed, both spots can be used."
        },
        "egressWeight": {
          "title": "Egress Weight",
          "description": "Controls how strongly the algorithm avoids placements that trap other aircraft.",
          "levels": {
            "low": "• Low (1x): Minimal penalty - prefers spots without traps but accepts trapping when needed",
            "medium": "• Medium (2x): Moderate penalty - works harder to avoid traps, may leave aircraft unplaced",
            "high": "• High (5x): Strong penalty - heavily prioritizes zero-trap placements over placement count"
          },
          "example": "Example: Spot A traps 2 aircraft (score = 2 × weight), Spot B traps 0 (score = 0). With High weight (5x), Spot A scores 10 vs Spot B scores 0, making Spot B strongly preferred."
        },
        "wasteWeight": {
          "title": "Waste Weight",
          "description": "Controls how strongly the algorithm avoids placing small aircraft in oversized spots. Helps reserve premium large spots for large aircraft that actually need them.",
          "levels": {
            "disabled": "• Disabled (0x): No penalty - ignores spot size mismatch, algorithm places freely",
            "low": "• Low (0.5x): Gentle nudge - slight preference for right-sized spots",
            "medium": "• Medium (1x): Balanced penalty - comparable to egress weight",
            "high": "• High (2x): Strong preference - works hard to avoid oversized spots",
            "veryHigh": "• Very High (3x): Extreme penalty - aggressively reserves large spots for large aircraft"
          },
          "example": "Example: Citation (small) considering large-capable spot has waste=3. With Medium weight (1x), waste penalty=3. With High weight (2x), penalty=6. If a right-sized small-only spot has score=0 and large spot has egress penalty=2, then: Medium makes scores 0 vs 5 (prefer small), High makes scores 0 vs 8 (strongly prefer small)."
        },
        "sortingStrategy": {
          "title": "Sorting Strategy",
          "description": "Controls the order in which aircraft are processed by the greedy placement algorithm. Different orderings can dramatically affect placement rates.",
          "strategies": {
            "arrivalOrder": "• Arrival Order: Process by arrival time (earliest first). Realistic but may waste flexible spots.",
            "sizeConstrained": "• Size-Constrained First: Place aircraft with fewer compatible spots first. Prevents wasting flexible spots on flexible aircraft.",
            "longestDwell": "• Longest Dwell First: Place longest-staying aircraft first. Ensures long dwells get priority.",
            "latestDeparture": "• Latest Departure First: Place latest-departing aircraft first. Optimizes overnight parking.",
            "hybrid": "• Hybrid: Combines size-constrained and longest-dwell (most constrained + longest first)."
          },
          "example": "Example: 2 spots (A=Small-only, B=Flex). Small aircraft arrives first, greedy places it at B (wastes flexibility). Large aircraft arrives, rejected (only B works, now occupied). With size-constrained ordering: Large placed first at B, small takes A → both placed!"
        },
        "sizeCategories": {
          "title": "Size Categories",
          "description": "Aircraft are assigned size categories based on wingspan. Spots have policies that restrict which aircraft sizes they accept, enabling flexible parking rules.",
          "sizes": {
            "verySmall": "• VS (Very Small): ~35-40ft wingspan (Cessna 172, Piper PA-28, Cirrus SR22)",
            "small": "• S (Small): ~50-60ft wingspan (Citations, Phenom 300, King Air 350, Learjet 45)",
            "midsize": "• M (Midsize): ~60-70ft wingspan (Challenger 604/605, Falcon 900, Gulfstream G280)",
            "superMidsize": "• SM (Super-Midsize): ~75-100ft wingspan (Falcon 7X, Gulfstream G500/G650)",
            "large": "• L (Large): ~100-120ft wingspan (Global 6000/7500, Gulfstream G700, BBJ)"
          },
          "spotPolicies": "Spot Policies: Each spot has an allowed sizes list that determines which aircraft can park there.",
          "policies": {
            "universal": "• Universal: [VS, S, M, SM, L] - accepts all aircraft sizes",
            "largeOnly": "• Large-only: [L] - reserves spot for large aircraft (prevents waste)",
            "commonJets": "• Common jets: [S, M] - blocks very-small and large aircraft"
          },
          "example": "Example: Spot A01 allows [S, M] (small and midsize only). A large aircraft (L) arrives but cannot use A01 due to size restrictions. It must find a spot that allows large aircraft."
        }
      }
    },
    "decisionLogDisplay": {
      "noEntries": "No decision log entries",
      "lane": "Lane",
      "timeConflict": "❌ Time conflict",
      "blocks": "📍 Blocks",
      "deps": "✓ Deps:",
      "aircraftSize": "Aircraft Size",
      "breakdown": "Breakdown",
      "collision": "Collision",
      "depsWarning": "Deps Warning",
      "durationAnalysis": {
        "exceedsBy": "Exceeds By",
        "minutes": "Minutes",
        "requiredDwell": "Required Dwell",
        "spotLimit": "Spot Limit",
        "title": "Duration Analysis"
      },
      "of": "Of",
      "otherOptions": "Other Options",
      "primary": "Primary",
      "primaryBlocker": "Primary Blocker",
      "quickFix": "Quick Fix",
      "rejectionReasons": {
        "durationExceeded": "Duration Exceeded",
        "geometryCollision": "Geometry Collision",
        "sizeIncompatible": "Size Incompatible",
        "spotsDisabled": "Spots Disabled",
        "timeConflicts": "Time Conflicts",
        "unknown": "Unknown"
      },
      "sizeAnalysis": {
        "aircraft": "Aircraft",
        "length": "Length",
        "none": "None",
        "spotsAllowing": "Spots Allowing",
        "spotsBySize": "Spots By Size",
        "title": "Size Analysis",
        "wingspan": "Wingspan"
      },
      "spots": "Spots",
      "timeAnalysis": {
        "aircraftDwell": "Aircraft Dwell",
        "conflictWindow": "Conflict Window",
        "minutes": "Minutes",
        "minutesSuffix": "Minutes Suffix",
        "peakCongestion": "Peak Congestion",
        "spotsOccupied": "Spots Occupied",
        "spotsOccupiedSuffix": "Spots Occupied Suffix",
        "timeConflicts": "Time Conflicts",
        "title": "Time Analysis"
      }
    }
  },
  "lastMinuteInsertion": {
    "dialog": {
      "aircraftStatus": {
        "spotUnknown": "Spot Unknown",
        "unknown": "Unknown",
        "unplaced": "Unplaced"
      },
      "buttons": {
        "checkAvailability": "Check Availability",
        "close": "Close"
      },
      "errors": {
        "invalidTimeRange": "Error: Invalid Time Range"
      },
      "labels": {
        "aircraft": "Aircraft",
        "arrivalTime": "Arrival Time",
        "departureTime": "Departure Time",
        "maxAircraftMoves": "Max Aircraft Moves"
      },
      "placeholders": {
        "selectAircraft": "Select Aircraft"
      },
      "results": {
        "failed": {
          "suggestions": "Suggestions",
          "title": "Failed"
        },
        "localRepair": {
          "message": "Local Repair",
          "title": "Local Repair"
        },
        "zeroDisruption": {
          "message": "Zero Disruption",
          "title": "Zero Disruption"
        }
      },
      "slider": {
        "marks": {
          "max": "Max",
          "two": "Two",
          "zero": "Zero"
        }
      },
      "title": "Dialog"
    }
  }
}
